module.exports = __webpack_public_path__ + "static/media/shipping-timed.8a1f3140.svg";